<template>
  <div class="col-12">
    <alert v-if="loading" class="light-shadow" />
    <div v-else>
      <div
        class="
          card
          overflow-auto
          shadow-card
          theme-card
          mobile-tablet-no-card
          p-5
        "
      >
        <div class="form-group mx-2 my-3" v-if="!loading">
          <input
            type="search"
            class="form-control pr-5 light-shadow"
            v-model.trim="searchContent"
            placeholder="Search by Recording Title"
          />
          <span>
            <i
              v-if="searchContent"
              class="fas fa-times cancel-icon"
              @click="searchContent = ''"
            ></i>
          </span>
        </div>
        <alert
          class="my-3 mx-2 border-lg-0 light-shadow"
          :hideLoader="true"
          v-if="filteredRecordings.length == 0"
        >
          No recordings to list.
        </alert>
        <div
          class="
            card
            mb-0
            shadow-card
            mobile-tablet-no-card
            p-2 p-md-0
            border-lg-0
            table-container
          "
          v-if="filteredRecordings.length > 0"
        >
          <table
            class="
              table table-sm table-striped
              mb-0
              responsive-mobile-tablet-table
            "
          >
            <thead>
              <tr>
                <th>Recording Title</th>
                <th>Recording Date</th>
                <th>Shared At</th>
                <th class="w-25 text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(recording, index) in filteredRecordings" :key="index">
                <td>
                  <b class="mobile-tablet-only mr-2">Recording Name: </b>
                  <div class="d-flex align-items-center">
                    <div
                      :title="recording.name"
                      :class="{
                        'recording-name': !isOptimized(recording),
                      }"
                    >
                      {{ recording.name }}
                    </div>
                    <span
                      v-if="!isOptimized(recording)"
                      v-tooltip.top="
                        'This recording is being optimized for playback. It may take a few minutes depending on the file size. You can still view the recording.'
                      "
                      class="badge badge-warning ml-2"
                    >
                      <i class="fas fa-spinner fa-spin"></i> Optimizing
                    </span>
                  </div>
                </td>
                <td>
                  <b class="mobile-tablet-only mr-2">Recording Date: </b>
                  {{ prettyDate(recording.recording_start) }}
                </td>
                <td>
                  <b class="mobile-tablet-only mr-2">Shared At: </b>
                  {{
                    recording.shared_at ? prettyDate(recording.shared_at) : "-"
                  }}
                </td>
                <td class="td-actions text-center">
                  <button
                    title="View Recording"
                    class="btn btn-outline-blue mx-1 my-1"
                    @click="viewRecoding(recording)"
                  >
                    <span> <icon type="eye" /> </span>
                  </button>
                  <button
                    v-if="loggedInUser.isAdmin || loggedInUser.isManagingAdmin"
                    title="Download Recording"
                    class="btn btn-outline-blue mx-1 my-1"
                    @click="downloadRecording(recording)"
                  >
                    <span> <icon type="download" /> </span>
                  </button>
                  <button
                    v-if="loggedInUser.isAdmin || loggedInUser.isManagingAdmin"
                    title="Delete Recording"
                    class="btn btn-outline-danger mx-1 my-1"
                    @click="deleteRecordingHelper(recording)"
                  >
                    <span
                      v-if="deleteLoading == recording.path"
                      class="fa fa-spin fa-circle-notch"
                    ></span>
                    <span v-else> <icon type="trash" /> </span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <recording-view-modal
      v-if="recording"
      v-model="showRecordingModal"
      :room-name="roomName"
      :recording="recording"
    />
  </div>
</template>
<script>
import dayjs from "dayjs";
import Swal from "sweetalert2";
import { mapActions, mapState } from "vuex";
import recordingViewModal from "../views/meetingRooms/RecordingViewModal.vue";
export default {
  name: "SharedRecordings",
  props: {
    currentUserId: {
      type: Number,
      required: true,
    },
  },
  components: {
    recordingViewModal,
  },
  data() {
    return {
      deleteLoading: null,
      searchContent: "",
      showRecordingModal: false,
      recording: null,
      roomName: "",
    };
  },
  mounted() {
    this.getSharedRecordings({
      userId: this.currentUserId,
    }).then((success) => {
      if (success && this.$route.query.record_id) {
        const recording = this.recordings.find(
          (recording) => recording.id == this.$route.query.record_id
        );
        if (recording) {
          setTimeout(() => {
            this.viewRecoding(recording);
          }, 0);
        } else {
          Swal.fire({
            title: "Error",
            text: "Recording not found",
            icon: "error",
          });
        }
      }
    });
  },
  watch: {
    "$route.query.record_id": {
      immediate: true, // Run on component load
      handler(newRecordId) {
        if (newRecordId && this.recordings.length) {
          const recording = this.recordings.find(
            (recording) => recording.id == newRecordId
          );
          if (recording) {
            setTimeout(() => {
              this.viewRecoding(recording);
            }, 0);
          } else {
            Swal.fire({
              title: "Error",
              text: "Recording not found",
              icon: "error",
            });
          }
        }
      },
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.users.sharedRecordings.loading,
      recordings: (state) => state.users.sharedRecordings.data || [],
      loggedInUser: (state) => state.auth.user,
    }),
    filteredRecordings: function () {
      return this.recordings.filter((recording) =>
        recording.name.toLowerCase().includes(this.searchContent.toLowerCase())
      );
    },
  },
  methods: {
    ...mapActions({
      getSharedRecordings: "users/getSharedRecordings",
      deleteSharedRecording: "users/deleteSharedRecording",
    }),
    downloadRecording: function (recording) {
      window.open(recording.url, "_blank");
    },
    deleteRecordingHelper: function (recording) {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this recording!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteLoading = recording.path;
          this.deleteSharedRecording({
            userId: this.currentUserId,
            data: {
              recording_path: recording.path,
            },
          }).then((res) => {
            if (res) {
              this.deleteLoading = null;
              this.getSharedRecordings({
                userId: this.currentUserId,
              });
            }
          });
        }
      });
    },
    prettyDate: function (date, onlyDate = false) {
      if (onlyDate) {
        return dayjs(date).format("MMM DD, YYYY");
      } else {
        return dayjs(date).format("MMM DD, YYYY  hh:mm A");
      }
    },
    viewRecoding: function (recording) {
      this.recording = recording;
      this.roomName = recording.name;
      this.$nextTick(() => {
        this.showRecordingModal = true;
      });
    },
    isOptimized: function (recording) {
      if (!recording || !recording.url) {
        return false;
      }
      if (recording.numeric_size && recording.numeric_size < 2 * 1024 * 1024) {
        return true;
      }

      const path = new URL(recording.url).pathname;
      return path && path.endsWith("_opt.mp4");
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  font-size: 0.9rem;
}
.form-group {
  position: relative;
}
.cancel-icon {
  z-index: 99;
  position: absolute;
  right: 13px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  color: #dc143c;
  cursor: pointer;
}

.recording-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 400px;
}
</style>
